import { ResolveFn, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { HxProductInfoService, HxProductSplitDefinitionService, ProductInfoModel, ProductSplitDefinitionFullModel } from 'hx-services';
import { ProductDefinitionListComponent } from '@adm-web-app/modules/product-definitions/list/product-definition-list.component';
import { ProductDefinitionSyncComponent } from '@adm-web-app/modules/product-definitions/sync/product-definition-sync.component';
import { ProductDefinitionTabComponent } from '@adm-web-app/modules/product-definitions/tab/product-definition-tab.component';
import { ProductDefSplitEditComponent } from '@adm-web-app/modules/product-definitions/split/edit/product-def-split-edit.component';

const resolveProductInfoFn: ResolveFn<ProductInfoModel> = route => inject(HxProductInfoService).getProductInfo(Number(route.paramMap.get('id')));
const resolveProductSplitDefFn: ResolveFn<ProductSplitDefinitionFullModel> = route => inject(HxProductSplitDefinitionService).getProductSplitDefinitionById(Number(route.paramMap.get('splitId')));

export const productDefinitionsRoutes: Routes = [
  {
    path: '', component: ProductDefinitionListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: ProductDefinitionTabComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit', component: ProductDefinitionTabComponent,
    resolve: {
      productDef: resolveProductInfoFn,
    },
    data: {
      breadcrumb: 'Edit'
    },
    children: [
      {
        path: 'split',
        data: {
          breadcrumb: 'Split'
        },
        children: [
          {
            path: '',
            redirectTo: 'new',
            pathMatch: 'full'
          },
          {
            path: 'new', component: ProductDefSplitEditComponent,
            data: {
              breadcrumb: 'Create'
            }
          },
          {
            path: ':splitId/edit', component: ProductDefSplitEditComponent,
            resolve: {
              splitDef: resolveProductSplitDefFn,
            },
            data: {
              breadcrumb: 'Edit'
            }
          },
        ]
      },
    ]
  },
  {
    path: ':id/sync', component: ProductDefinitionSyncComponent,
    resolve: {
      model: resolveProductInfoFn,
    },
    data: {
      breadcrumb: 'Sync'
    }
  },
];
